import React, { Component } from "react";
import {
    NavBar,
    Icon,
    List,
    Button,
    WhiteSpace,
    WingBlank,
    Pagination,
    InputItem,
    Toast,
    SearchBar,
} from "antd-mobile";
import { Link } from "react-router-dom";
import "./admin.scss";
import { createForm } from "rc-form";
import { connect } from "dva";

const Item = List.Item;
const Brief = Item.Brief;
const selectedContainer = {
    position: "fixed",
    width: "100%",
    top: "45px",
    background: "#f5f5f5",
    height: "100%",
    zIndex: "11",
    transition: "left 0.4s",
};
const plus_icon = require("../../../../assets/images/icon/plus_icon.png");
@connect(({ enterpriseadmin }) => ({ enterpriseadmin }))
export class adminList extends Component {
    state = {
        adminListDatas: [],
        pageNo: 1,
        pageTotalNum: 0,
        drawerLeft: document.body.clientWidth,
        loginName: "",
        uid: "",
    };
    componentDidMount() {

    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    getAdminList(page, loginName) {
        //延时1s，防止后台接口操作太频繁
        Toast.loading('加载中...', 1);
        setTimeout(() => {
            this.props
                .dispatch({
                    type: "enterpriseadmin/getEnterpriseAdminList",
                    payload: {
                        page: {
                            pageNo: page,
                            pageSize: 10,
                        },
                        loginName,
                    },
                })
                .then(res => {
                    if (res) {
                        this.setState({
                            drawerLeft: document.body.clientWidth,
                        });
                    }
                });
        }, 800);
    }
    onPageChange(e) {
        const { pageTotalNum } = this.props.enterpriseadmin;
        e = e > pageTotalNum ? pageTotalNum : e;
        this.getAdminList(e);
    }
    // 打开企业管理员查询
    onOpenChange = () => {
        this.setState({
            drawerLeft: 0,
        });
    };
    onInfoAccountId = e => {
        this.setState({
            uid: e,
        });
    };
    onInfoAccountName = e => {
        this.setState({
            loginName: e,
        });
    };
    onSearch = () => {
        this.props.form.validateFields({ force: false }, error => {
            this.getAdminList(1, this.props.form.getFieldsValue().loginName);
        });
    };
    onSearchAll = () => {
        this.setState({
            loginName: null,
            uid: null,
        });
        setTimeout(() => {
            this.getAdminList(1);
        }, 0);
    };
    render() {
        const { drawerLeft, loginName } = this.state;
        const { enterpriseadmin } = this.props;
        const { adminListDatas, pageTotalNum, pageNo } = enterpriseadmin;
        const { getFieldProps } = this.props.form;
        return (
            // <span>111</span>
            <div className="adminList">
                <div className="header-sticky">
                    <NavBar
                        icon={<Icon type="left" />}
                        onLeftClick={() => this.props.history.goBack()}
                        rightContent={[
                            <Icon
                                key="0"
                                type="search"
                                onClick={this.onOpenChange}
                                style={{ marginRight: "16px" }}
                            />,
                            <Link to="/enterprise/admin/enterpriseAdminAdd" key="1">
                                <img src={plus_icon} width="24" />,
                            </Link>,
                        ]}
                    >
                        企业管理员列表
                    </NavBar>
                </div>
                <div className="sub-container">
                    <List>
                        {adminListDatas.map((i, index) => (
                            <Item
                                key={index}
                                arrow="horizontal"
                                multipleLine
                                onClick={() =>
                                    this.props.history.push(
                                        `/enterpriseAdminDetail/${i.loginName}/${i.loginFlag}/${i.id}`,
                                    )
                                }
                            >
                                名称： {i.loginName}{" "}
                                &ensp;&ensp;&ensp;ID: {i.uid}
                            </Item>
                        ))}
                    </List>
                    <WhiteSpace />
                    <WingBlank>
                        <SearchBar
                            placeholder="请输入跳转页面"
                            onSubmit={value => this.onPageChange(value)}
                        />
                    </WingBlank>
                    <WhiteSpace />
                    <WingBlank>
                        {pageTotalNum > 0 ? (
                            <Pagination
                                total={pageTotalNum}
                                current={pageNo}
                                locale={{
                                    prevText: "上一页",
                                    nextText: "下一页",
                                }}
                                onChange={e => this.onPageChange(e)}
                            />
                        ) : (
                                ""
                            )}
                    </WingBlank>
                </div>
                <div style={{ ...selectedContainer, left: drawerLeft }}>
                    <List renderHeader="搜索企业管理员">
                        <InputItem
                            {...getFieldProps("loginName", {
                                initialValue: loginName,
                            })}
                            clear
                            onChange={e => this.onInfoAccountName(e)}
                            placeholder="请输入账号"
                            key="1"
                        >
                            账号
                        </InputItem>
                        <Item>
                            <Button 
                                type="primary" 
                                inline 
                                size="small"
                                style={{ marginRight: '4px' }} 
                                onClick={this.onSearch}>
                                确定
                            </Button>
                            
                            <Button 
                                type="primary" 
                                inline 
                                size="small"
                                style={{ marginRight: '4px' }} 
                                onClick={this.onSearchAll}>
                                全部
                            </Button>
                            
                            <Button
                                type="ghost"
                                inline
                                size="small"
                                style={{ marginRight: '4px' }}
                                onClick={() =>
                                    this.setState({
                                        drawerLeft: document.body.clientWidth,
                                    })
                                }
                            >
                                返回
                            </Button>
                        </Item>
                    </List>
                </div>
            </div>
        )
    }
}

export default createForm()(adminList);
